import { Text, Textarea } from '@mantine/core'
import { Notebook } from 'lucide-react'
import { useCaseCreationStore } from '@/store/useCaseCreationStore'

function Notes() {
  const { notes, setNotes } = useCaseCreationStore()

  return (
    <div
      className={`space-y-6 border border-light-gray-20 p-4 min-w-[551px] w-full min-h-[min(140px,15vh)] gap-4 rounded-md overflow-y-auto`}
    >
      {/* Notes Section */}
      <div className="h-full">
        <div className="flex items-center gap-2 mb-md border-b border-light-gray-20 pb-1 mb-4">
          <Notebook color="#64676A" width={20} height={20} />
          <Text size="md" fw={600} c="grey.4">
            Notes
          </Text>
        </div>
        <div className="space-y-2 bg-off-white p-4 rounded-md h-full">
          <Textarea
            placeholder="Add your notes here"
            value={notes}
            onChange={event => setNotes(event.currentTarget.value)}
            minRows={4}
            autosize
            styles={{
              input: {
                backgroundColor: 'transparent',
                border: 'none',
                fontStyle: notes ? 'normal' : 'italic',
                fontSize: '14px',
                color: notes ? '#495057' : '#868e96',
                fontWeight: notes ? 400 : 600,
                padding: '0',
                '&:focus': {
                  border: 'none',
                  outline: 'none',
                },
              },
              wrapper: {
                backgroundColor: 'transparent',
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default Notes
